/**
 * sOSSiety brand color tokens — fonte única de verdade para usos em JS/TS
 * (inline styles, objetos de configuração, etc.)
 *
 * Para Tailwind, use as classes: bg-sossiety-red, text-sossiety-red, etc.
 */
export const brandColors = {
  red: {
    DEFAULT: '#D72E16',
    hover:   '#B8251A',
    500:     '#E05A5A',
    600:     '#CB4141',
    700:     '#9E2E2E',
  },
  blue: {
    500: '#6897FF',
    600: '#3C75FF',
    700: '#2A59CC',
  },
  grey: {
    100: '#E1E1E1',
    200: '#BDBDBD',
    300: '#8D8D8D',
    400: '#5C5C5C',
    500: '#2C2E32',
  },
  success: '#2ECC71',
  alert:   '#F39C12',
  error:   '#E74C3C',
} as const;

/** Atalhos para os tokens mais usados */
export const SOSSIETY_RED       = brandColors.red.DEFAULT;
export const SOSSIETY_RED_HOVER = brandColors.red.hover;

/** Cores semânticas de status para Roll Review */
export const REVIEW_COLOR_PENDING   = brandColors.alert;     // #F39C12 — amber
export const REVIEW_COLOR_IN_REVIEW = brandColors.blue[500]; // #6897FF — azul
export const REVIEW_COLOR_DELIVERED = brandColors.success;   // #2ECC71 — verde
export const REVIEW_COLOR_EXPIRED   = brandColors.grey[300]; // #8D8D8D — muted
export const REVIEW_COLOR_DECLINED  = brandColors.error;     // #E74C3C — vermelho
